/** Production host policy. Hostname selection never grants access to member data. */
export const WEBSITE_ORIGIN = "https://growth-sync.com";
export const APP_ORIGIN = "https://app.growth-sync.com";
export const APP_HOST = "app.growth-sync.com";

export function isProductionAppHost(hostname: string): boolean {
  return ["growth-sync.com", "www.growth-sync.com", APP_HOST].includes(hostname.toLowerCase());
}

export const MARKETING_ROUTES = [
  "/features",
  "/for",
  "/pricing",
  "/about",
  "/faq",
  "/safety",
  "/contact",
  "/how-it-works",
  "/get-app",
  "/networking-for-entrepreneurs",
  "/meet-business-partners",
  "/business-networking-app",
];

export const protectedRoutes = [
  "/dashboard",
  "/admin",
  "/discover",
  "/messages",
  "/events",
  "/communities",
  "/profile",
  "/settings",
  "/notifications",
  "/leaderboard",
  "/referrals",
  "/invite-friends",
  "/ambassador-program",
  "/onboarding",
  "/checkout",
  "/host",
  "/opportunities",
  "/services",
  "/weekly-summary",
  "/sync",
];

function matches(path: string, routes: readonly string[]): boolean {
  return routes.some(route => path === route || path.startsWith(`${route}/`));
}

export function domainRoute(url: URL, method: string, native: boolean):
  { kind: "redirect" | "rewrite"; url: URL } | null {
  if (method !== "GET" && method !== "HEAD") return null;
  const host = url.hostname.toLowerCase();
  const path = url.pathname;
  if (host === APP_HOST) {
    if (path === "/") return {
      kind: native ? "rewrite" : "redirect",
      url: new URL(`${native ? "/welcome" : "/auth/login"}${url.search}`, APP_ORIGIN),
    };
    if (matches(path, MARKETING_ROUTES) && !native) {
      return { kind: "redirect", url: new URL(`${path}${url.search}`, WEBSITE_ORIGIN) };
    }
  }
  // Native Preferences and browser OAuth PKCE state are origin-bound. Existing phone
  // apps remain on the apex; callbacks and password-reset pages complete there too.
  if ((host === "growth-sync.com" || host === "www.growth-sync.com") && !native) {
    const entryPages = ["/auth/login", "/auth/signup", "/auth/forgot-password", "/welcome", "/upgrade", "/claim", "/profiles", "/report", "/tickets", "/verification-required", "/verify-phone", "/scan", "/v2"];
    if (path === "/auth" || matches(path, protectedRoutes) || matches(path, entryPages)) {
      return { kind: "redirect", url: new URL(`${path}${url.search}`, APP_ORIGIN) };
    }
  }
  return null;
}

/** Next's local server normalizes nextUrl to localhost; use the actual HTTP Host.
 * Only exact public hosts are handled by domainRoute, never forwarded-host input. */
export function requestDomainUrl(request: {url: string; headers: Headers}): URL {
  const url = new URL(request.url);
  const host = request.headers.get("host");
  if (host) url.host = host;
  return url;
}
